module.exports = __webpack_public_path__ + "img/Bear27.6a85befc.jpg";